<script>
    import { createEventDispatcher } from 'svelte';
    export let events;
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const dispatch = createEventDispatcher();

    function eventSelected(eventSelected) {
        dispatch('eventSelected', {
            event: eventSelected
        });
    }
</script>
    <section id="card-container">
        {#each events as event (event.id)}
            <div class="card" on:click={()=>eventSelected(event)}>
                <img src={event.groupPhotoLink} alt="meetup graphic"/><br/>
                {new Date(event.time).toLocaleDateString(undefined)}
            </div>
        {/each}    
    </section>

<style>
    #card-container {
        width: 90vw;
        display: flex;
        overflow: auto;
    }
    .card {
        max-width: 150px;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 10px;
        cursor: pointer;
    }
    .card img{
        width: auto;
        height: 150px;
    }
</style>